import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { accessCheck } from '../../../utils/accessCheck';
import { accessKeys } from '../../../statics/accessKeys';
import { IconX } from '@tabler/icons-react';
import { toast } from 'sonner';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';

const GoogleManagerAccountModal = () => {

    const [show, setShow] = useState(false);
    const [accountData, setAccountData] = useState(null);

    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => { setShow(true) };

    const getData = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getGoogleAdsManagerAccount);
        handleShow();
        loadingHide();
        if (resp?.responseCode == 200) {
            setAccountData(resp?.data);
        } else {
            setAccountData(null)
        }
    }

    async function addManagerAccount() {
        let postData = {
            "clientId": document.getElementById("google-ad-client-id")?.value?.trim(),
            "clientSecret": document.getElementById("google-ad-client-secret")?.value?.trim(),
            "developerToken": document.getElementById("google-ad-developer-token")?.value?.trim(),
            "refreshToken": document.getElementById("google-ad-refresh-token")?.value?.trim(),
            "loginCustomerId": document.getElementById("google-ad-customer-login-id")?.value?.trim()
        }
        if (!postData?.clientId || !postData?.clientSecret || !postData?.developerToken || !postData?.refreshToken || !postData?.loginCustomerId) {
            toast.error('Please fill in all the required fields.');
            return;
        }
        loadingShow();
        let url = accountData?.clientId ? urlApi.updateGoogleAdsMangerAccountData : urlApi.addGoogleManagerAccount
        let resp = await postApi(postData, url);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            handleClose();
        } else {
            toast.error(resp.message);
        }
    }

    return (
        <>
            <button className='mb-0 text-xs font-light text-orange-600 italic !border rounded-lg border-orange-600 !px-3 !py-1 h-max' onClick={() => getData()}>Manager Account</button>
            <Modal show={show} onHide={handleClose} size='xl' backdrop="static" >
                <Modal.Body className='rounded-xl p-0'>
                    <div className="flex justify-between items-center pt-3 px-4">
                        <p className="text-md font-semibold mb-0">Your Google Manager Account</p>
                        <button onClick={handleClose}> <IconX /></button>
                    </div>
                    <hr className='my-2' />
                    <div className='px-2'>
                        {!accountData?.clientId &&
                            <div>
                                <p className="text-orange-700 mb-1 text-sm">
                                    *Your Google Ads account is currently managed through our <span className="font-medium text-primary">Attriva Google Manager Account</span>.
                                    If you'd like to switch, you can add your own manager account at any time.
                                </p>
                                <p className="text-xs text-gray-500 italic mb-4">
                                    (This is completely optional and not required.)
                                </p>
                            </div>}

                        {accessCheck(accessKeys?.setGoogleAdsClientId) && <div className='bg-white px-3 pt-2 pb-3 !mb-4 rounded-lg'>
                            <label htmlFor="" className='text-md font-semibold mb-2.5'>Google Ads Manager Account Credential</label>
                            <div className="grid grid-cols-1 md:grid-cols-2 !gap-3 mb-1">
                                <div className="!mb-1">
                                    <label htmlFor="google-ad-client-id" className='text-sm  mb-1.5'>Client ID*</label>
                                    <input type="text" id="google-ad-client-id" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Enter your Google Ad Account ID" defaultValue={accountData?.clientId} />
                                </div>
                                <div className="!mb-1">
                                    <label htmlFor="google-ad-client-secret" className='text-sm  mb-1.5'>Client Secret*</label>
                                    <input type="text" id="google-ad-client-secret" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Give your Google Ad Account a Name" defaultValue={accountData?.clientSecret} />
                                </div>
                                <div className="!mb-1">
                                    <label htmlFor="google-ad-developer-token" className='text-sm  mb-1.5'>Developer Token*</label>
                                    <input type="text" id="google-ad-developer-token" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Give your Google Ad Account a Name" defaultValue={accountData?.developerToken} />
                                </div>
                                <div className="!mb-1">
                                    <label htmlFor="google-ad-refresh-token" className='text-sm  mb-1.5'>Refresh Token*</label>
                                    <input type="text" id="google-ad-refresh-token" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Give your Google Ad Account a Name" defaultValue={accountData?.refreshToken} />
                                </div>
                                <div className="!mb-1">
                                    <label htmlFor="google-ad-customer-login-id" className='text-sm  mb-1.5'>Login Customer ID*</label>
                                    <input type="text" id="google-ad-customer-login-id" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Give your Google Ad Account a Name" defaultValue={accountData?.loginCustomerId} />
                                </div>
                            </div>
                            <div className='mb-0 flex justify-end'>
                                <button className='text-sm font-semibold !bg-primary px-4 py-2 text-white rounded-full' onClick={() => addManagerAccount()}>{accountData?.clientId ? "Update" : "Add"}</button>
                            </div>
                        </div>}

                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default GoogleManagerAccountModal